import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import "./EventSummary.css";

const EventSummary = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [eventInfo, setEventInfo] = useState(null);
  const [participations, setParticipations] = useState([]);
  const [summary, setSummary] = useState([]);
  const [absentReasons, setAbsentReasons] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // イベント情報を取得
        const eventRes = await api.get(`/events/${eventId}/`);
        setEventInfo(eventRes.data);

        // 参加状況の取得
        const partRes = await api.get(`/events/${eventId}/results/`);
        const parts = partRes.data;
        setParticipations(parts);

        // 部署別集計を作成
        const departments = [...new Set(parts.map((p) => p.departmentName || "不明"))];
        const newSummary = departments.map((dept) => {
          const group = parts.filter((p) => p.departmentName === dept);
          const joined = group.filter((p) => p.is_participating || p.isParticipating).length;
          const totalEmp = group.length;
          return {
            type: dept,
            joined,
            totalEmp,
            notJoined: totalEmp - joined,
          };
        });

        // 合計行を追加
        const totalJoined = newSummary.reduce((sum, t) => sum + t.joined, 0);
        const totalEmpAll = newSummary.reduce((sum, t) => sum + t.totalEmp, 0);
        const totalNotJoined = totalEmpAll - totalJoined;

        newSummary.push({
          type: "合計",
          joined: totalJoined,
          totalEmp: totalEmpAll,
          notJoined: totalNotJoined,
        });

        setSummary(newSummary);

        // 不参加理由のリスト
        const reasons = parts
          .filter((p) => !(p.is_participating || p.isParticipating) && p.reason)
          .map((p) => ({
            memberId: p.memberId,
            employeeName: p.employeeName,
            reason: p.reason,
          }));
        setAbsentReasons(reasons);
      } catch (err) {
        console.error("集計データの取得エラー:", err);
      }
    };

    fetchData();
  }, [eventId]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="summary-container">
      <h2 className="summary-title">イベント集計</h2>

      {eventInfo && (
        <div className="summary-header">
          <p>
            <strong>イベント名:</strong> {eventInfo.eventName}
          </p>
          <p>
            <strong>開催日:</strong>{" "}
            {new Date(eventInfo.eventDate).toLocaleDateString("ja-JP")}
          </p>
        </div>
      )}

      {/* --- 表示 --- */}
      <table className="summary-table">
        <thead>
          <tr>
            <th>区分（部署）</th>
            <th>参加人数</th>
            <th>不参加人数</th>
            <th>合計人数</th>
          </tr>
        </thead>
        <tbody>
          {summary.map((row, i) => (
            <tr key={i}>
              <td>{row.type}</td>
              <td>
                {row.type !== "合計"
                  ? `${row.joined} / ${row.totalEmp}`
                  : `${row.joined}人`}
              </td>
              <td>
                {row.type !== "合計"
                  ? `${row.notJoined}人`
                  : `${row.notJoined}人`}
              </td>
              <td>
                {row.type !== "合計"
                  ? `${row.totalEmp}人`
                  : `${row.totalEmp}人`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* --- 不参加理由一覧 --- */}
      <h3 className="reason-title">不参加理由一覧</h3>
      <table className="reason-table">
        <thead>
          <tr>
            <th>社員番号</th>
            <th>氏名</th>
            <th>不参加理由</th>
          </tr>
        </thead>
        <tbody>
          {absentReasons.length > 0 ? (
            absentReasons.map((r, idx) => (
              <tr key={idx}>
                <td>{r.memberId}</td>
                <td>{r.employeeName}</td>
                <td>{r.reason}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", color: "gray" }}>
                不参加理由は登録されていません。
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* --- ボタン --- */}
      <div className="button-group">
        <button type="button" className="btn-print" onClick={handlePrint}>印刷</button>
        <button type="button" className="btn-back" onClick={() => navigate("/admin/create_event")}>戻る</button>
      </div>
    </div>
  );
};

export default EventSummary;
